const css = `._colorPicker_19tup_1 {
  display: grid;
  grid-template-columns: repeat(6, 24px);
}
._colorPickerButton_19tup_5 {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
  text-indent: -99999em;
  overflow: hidden;
}
._colorPickerButtonActive_19tup_17 {
  border: 1px dotted var(--border-color);
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "colorPicker": "_colorPicker_19tup_1",
  "colorPickerButton": "_colorPickerButton_19tup_5",
  "colorPickerButtonActive": "_colorPickerButtonActive_19tup_17"
};